module.exports = __webpack_public_path__ + "static/disrupting-investments-0b768e093c3fb2895a7248c8c2df4158.jpg";